export default {
  fetch_passage_list: false,
  active_passage_grade: {},
  active_passage: null,
  passage_result: null,
  fetchingpassage: false,
  passageList: [],
  active_passage_grade: {},

  //MCQ CRUD
  questions: [],
  active_mcq: null,
  passage_language: "",
};
